/**
 * MODULE: EmailTemplateFormCatalogBridge.tsx
 * PURPOSE: Route assistant email_template form_catalog to golden-path EmailTemplateCreateModal (single path).
 */

import { requestOpenEmailTemplateCreate } from '@shared/lib/frontend/utils/emailTemplateCreateBridge';
import type { FormRequest } from '../../hooks/assistant/types';
import { extractEmailTemplatePrefillFromFormRequest } from './assistantFormRequestUtils';

type EmailTemplateFormCatalogBridgeProps = {
  formRequest: FormRequest;
  onSubmit: (data: Record<string, unknown>) => void;
  onCancel: () => void;
  disabled?: boolean;
};

export function EmailTemplateFormCatalogBridge({
  formRequest,
  onCancel,
  disabled = false,
}: EmailTemplateFormCatalogBridgeProps) {
  const prefill = extractEmailTemplatePrefillFromFormRequest(formRequest);
  const fieldLabels = formRequest.fields
    .filter((f) => f.required)
    .map((f) => f.label)
    .join(', ');

  const openEditor = () => {
    requestOpenEmailTemplateCreate({ prefill, coachInAssistant: true });
    onCancel();
  };

  return (
    <div className="space-y-3" data-testid="assistant-email-template-golden-path">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Create Email Template</h3>
      <div
        className="rounded-lg border border-blue-200 bg-blue-50/80 p-3 dark:border-blue-900/50 dark:bg-blue-950/30"
        data-testid="assistant-email-template-golden-path-banner"
      >
        <p className="text-xs text-blue-900 dark:text-blue-100">
          Use the template editor for merge tags, AI generation, and team sharing — the same store
          Assistant uses to send and Messaging uses in sequences.
        </p>
        {fieldLabels ? (
          <p className="mt-1 text-[11px] text-blue-800/90 dark:text-blue-200/80">
            You will fill in: {fieldLabels}
          </p>
        ) : null}
        <button
          type="button"
          disabled={disabled}
          onClick={openEditor}
          className="mt-2 w-full rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-blue-700 disabled:opacity-50"
          data-testid="assistant-email-template-open-editor"
        >
          Open template editor
        </button>
      </div>
    </div>
  );
}
